/* eslint-disable */
export const outIcon = {
  data: `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.744568" y="0.984375" width="12" height="12" rx="6" fill="#FE2E0F"/>
<path d="M9.40482 6.98346H4.08435M4.08435 6.98346L6.07953 4.98828M4.08435 6.98346L6.07953 8.97863" stroke="white" stroke-width="0.918209" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  name: 'out' as const,
};
